import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { catchError, map } from 'rxjs/operators';

//SERVICES
import { ConfigService } from '../services/config.service';
//MODELS
import { Region } from '../models/region.interface';
import { Observable, of, Subscriber } from 'rxjs';
import { CompassApiResponse } from '../models/compass-api-response.interface';
import { CompassApiStatusEnum } from '../models/compass-api-status-enum';


@Injectable({providedIn: SharedModule})
export class CompassAPIRegionsService {

	public params = new URLSearchParams();
	public config: any;
	public baseUrl: string;

	constructor(
		private httpClient: HttpClient,
		private _configService: ConfigService
	) { 

		this.config = this._configService.getCompassApi();
		//console.log('this.config:', this.config);
		this.baseUrl = this.config.baseUrl + 'regions';
	}


	/**
	 * Get Regions
	 * @param limit 
	 * @returns 
	 */
	public getRegions (limit: number = null): Observable<Region[]>{
		let url = this.baseUrl;
		if(limit) url = url + '?limit=' + limit;
		//console.log('API.getRegions().url', url);

		return this.httpClient
			.get(url, { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getRegions.res:', res);
				if(res.status == CompassApiStatusEnum.ok && res.total > 0) {
					const regions: Region[] = res.results;
					return regions;
				} else {
					return null;
				}
			}));
	}

	/**
	 * Get Region by ID or Slug
	 * @param idOrSlug 
	 * @returns 
	 */
	public getRegionByIdOrSlug (idOrSlug: string): Observable<Region>{
		let url = this.baseUrl + '/' + idOrSlug;
		//console.log('API.getRegionByIdOrSlug().url:', url);

		return this.httpClient
			.get(url, { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getRegionByIdOrSlug.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					const region: Region = res.result;
					return region;
				} else {
					return null;
				}
			}));
	}



	/**
	 * Post (create) Regions
	 * @param data:Region
	 * @returns 
	 */
	public postRegions (data:Region){
		let url = this.baseUrl,
			body = data,
			options = { 
				headers: this.config.headers,
			};
		//console.log('API.postRegions().url', url);
		// console.log('postRegions().body', body);
		// console.log('postRegions().options', options);
		//return this.httpClient.post(url, body, options);

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postRegions.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;//uses error
				}
			}));
	}


	/**
	 * Put (update) Regions
	 * @param id 
	 * @param data:Region
	 * @returns 
	 */
	public putRegions (id: string, data:Region): Observable<Region>{
		let url = this.baseUrl + '/' + id,
			body = data,
			options = { 
				headers: this.config.headers,
			};
		//console.log('putRegions().url:', url);
		// console.log('putRegions().body', body);
		// console.log('putRegions().options', options);

		return this.httpClient
			.put(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putRegions.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;//uses error
				}
			}));
	}


	/**
	 * Delete Region
	 * @param id 
	 * @returns 
	 */
	 public deleteRegions (id: string){
		let url = this.baseUrl + '/' + id,
		options = { 
			headers: this.config.headers,
		};
		//console.log('API.deleteRegions().url', url);
		//return this.httpClient.delete(url, options);
		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.deleteRegions.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;
				}
			}));
	}





	/**
	 * Post (create) Regions assets
	 * @param slug
	 * @param data:form data
	 * @returns
	 */
	 public postRegionsAssets (slug:string, data:any){
		let url = this.baseUrl + '/' + slug + '/assets',
			body = data,
			options = {
				headers: this.config.headersMulti,
			};
		// console.log('API.postRegionsAssets().url', url);
		// console.log('API.postRegionsAssets().body', body);
		// console.log('API.postRegionsAssets().options', options);

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postRegionsAssets.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.results;
				} else {
					return res;//uses error
				}
			}));
	}


	/**
	 * Delete Regions assets
	 * @param slug
	 * @param name
	 * @returns
	 */
	 public deleteRegionsAssets (slug:string, name:string){
		let url = this.baseUrl + '/' + slug + '/assets/' + name,
			//body = data,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.deleteRegionsAssets().url', url);
		//console.log('API.deleteRegionsAssets().options', options);

		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.deleteRegionsAssets.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}



	

}